export const regionData = [
  {region: '中国大陆', data: {cnName: '中国大陆', enName: 'China', code: '+86', continent: '亚洲'}}, {
    region: '中国香港',
    data: {cnName: '中国香港', enName: 'Hong Kong, China', code: '+852', continent: '亚洲'}
  }, {region: '中国澳门', data: {cnName: '中国澳门', enName: 'Macao, China', code: '+853', continent: '亚洲'}}, {
    region: '中国台湾',
    data: {cnName: '中国台湾', enName: 'Taiwan, China', code: '+886', continent: '亚洲'}
  },
  {region: '澳大利亚', data: {cnName: '澳大利亚', enName: 'Australia', code: '+61', continent: '大洋洲'}}, {
    region: '新西兰',
    data: {cnName: '新西兰', enName: 'New Zealand', code: '+64', continent: '大洋洲'}
  },
  {region: '马来西亚', data: {cnName: '马来西亚', enName: 'Malaysia', code: '+60', continent: '亚洲'}}, {
    region: '印度尼西亚',
    data: {cnName: '印度尼西亚', enName: 'Indonesia', code: '+62', continent: '亚洲'}
  }, {region: '菲律宾', data: {cnName: '菲律宾', enName: 'Philippines', code: '+63', continent: '亚洲'}}, {
    region: '新加坡',
    data: {cnName: '新加坡', enName: 'Singapore', code: '+65', continent: '亚洲'}
  }, {region: '泰国', data: {cnName: '泰国', enName: 'Thailand', code: '+66', continent: '亚洲'}}, {
    region: '日本',
    data: {cnName: '日本', enName: 'Japan', code: '+81', continent: '亚洲'}
  }, {region: '韩国', data: {cnName: '韩国', enName: 'Korea', code: '+82', continent: '亚洲'}}, {
    region: '塔吉克斯坦',
    data: {cnName: '塔吉克斯坦', enName: 'Tajikstan', code: '+7', continent: '亚洲'}
  }, {region: '哈萨克斯坦', data: {cnName: '哈萨克斯坦', enName: 'Kazakstan', code: '+7', continent: '亚洲'}}, {
    region: '越南',
    data: {cnName: '越南', enName: 'Vietnam', code: '+84', continent: '亚洲'}
  }, {region: '土耳其', data: {cnName: '土耳其', enName: 'Turkey', code: '+90', continent: '亚洲'}}, {
    region: '印度',
    data: {cnName: '印度', enName: 'India', code: '+91', continent: '亚洲'}
  }, {region: '巴基斯坦', data: {cnName: '巴基斯坦', enName: 'Pakistan', code: '+92', continent: '亚洲'}}, {
    region: '阿富汗',
    data: {cnName: '阿富汗', enName: 'Afghanistan', code: '+93', continent: '亚洲'}
  }, {region: '斯里兰卡', data: {cnName: '斯里兰卡', enName: 'Sri Lanka', code: '+94', continent: '亚洲'}}, {
    region: '缅甸',
    data: {cnName: '缅甸', enName: 'Burma', code: '+95', continent: '亚洲'}
  }, {region: '伊朗', data: {cnName: '伊朗', enName: 'Iran', code: '+98', continent: '亚洲'}}, {
    region: '亚美尼亚',
    data: {cnName: '亚美尼亚', enName: 'Armenia', code: '+374', continent: '亚洲'}
  }, {region: '东帝汶', data: {cnName: '东帝汶', enName: 'East timor', code: '+670', continent: '亚洲'}}, {
    region: '文莱',
    data: {cnName: '文莱', enName: 'Brunei', code: '+673', continent: '亚洲'}
  }, {region: '朝鲜', data: {cnName: '朝鲜', enName: 'North Korea', code: '+850', continent: '亚洲'}}, {
    region: '柬埔寨',
    data: {cnName: '柬埔寨', enName: 'Kampuchea (Cambodia )', code: '+855', continent: '亚洲'}
  }, {region: '老挝', data: {cnName: '老挝', enName: 'Laos', code: '+856', continent: '亚洲'}}, {
    region: '孟加拉国',
    data: {cnName: '孟加拉国', enName: 'Bangladesh', code: '+880', continent: '亚洲'}
  }, {region: '马尔代夫', data: {cnName: '马尔代夫', enName: 'Maldives', code: '+960', continent: '亚洲'}}, {
    region: '黎巴嫩',
    data: {cnName: '黎巴嫩', enName: 'Lebanon', code: '+961', continent: '亚洲'}
  }, {region: '约旦', data: {cnName: '约旦', enName: 'Jordan', code: '+962', continent: '亚洲'}}, {
    region: '叙利亚',
    data: {cnName: '叙利亚', enName: 'Syria', code: '+963', continent: '亚洲'}
  }, {region: '伊拉克', data: {cnName: '伊拉克', enName: 'Iraq', code: '+964', continent: '亚洲'}}, {
    region: '科威特',
    data: {cnName: '科威特', enName: 'Kuwait', code: '+965', continent: '亚洲'}
  }, {region: '沙特阿拉伯', data: {cnName: '沙特阿拉伯', enName: 'Saudi Arabia', code: '+966', continent: '亚洲'}}, {
    region: '也门',
    data: {cnName: '也门', enName: 'Yemen', code: '+967', continent: '亚洲'}
  }, {region: '阿曼', data: {cnName: '阿曼', enName: 'Oman', code: '+968', continent: '亚洲'}}, {
    region: '巴勒斯坦',
    data: {cnName: '巴勒斯坦', enName: 'Palestinian', code: '+970', continent: '亚洲'}
  }, {region: '阿联酋', data: {cnName: '阿联酋', enName: 'U.A.E', code: '+971', continent: '亚洲'}}, {
    region: '以色列',
    data: {cnName: '以色列', enName: 'Israel', code: '+972', continent: '亚洲'}
  }, {region: '巴林', data: {cnName: '巴林', enName: 'Bahrain', code: '+973', continent: '亚洲'}}, {
    region: '卡塔尔',
    data: {cnName: '卡塔尔', enName: 'Qatar', code: '+974', continent: '亚洲'}
  }, {region: '不丹', data: {cnName: '不丹', enName: 'Bhutan', code: '+975', continent: '亚洲'}}, {
    region: '蒙古',
    data: {cnName: '蒙古', enName: 'Mongolia', code: '+976', continent: '亚洲'}
  }, {region: '尼泊尔', data: {cnName: '尼泊尔', enName: 'Nepal', code: '+977', continent: '亚洲'}}, {
    region: '土库曼斯坦',
    data: {cnName: '土库曼斯坦', enName: 'Turkmenistan', code: '+993', continent: '亚洲'}
  }, {region: '阿塞拜疆', data: {cnName: '阿塞拜疆', enName: 'Azerbaijan', code: '+994', continent: '亚洲'}}, {
    region: '格鲁吉亚',
    data: {cnName: '格鲁吉亚', enName: 'Georgia', code: '+995', continent: '亚洲'}
  }, {region: '吉尔吉斯斯坦', data: {cnName: '吉尔吉斯斯坦', enName: 'Kyrgyzstan', code: '+996', continent: '亚洲'}}, {
    region: '乌兹别克斯坦',
    data: {cnName: '乌兹别克斯坦', enName: 'Uzbekistan', code: '+998', continent: '亚洲'}
  }, {region: '英国', data: {cnName: '英国', enName: 'United Kiongdom', code: '+44', continent: '欧洲'}}, {
    region: '德国',
    data: {cnName: '德国', enName: 'Germany', code: '+49', continent: '欧洲'}
  }, {region: '意大利', data: {cnName: '意大利', enName: 'Italy', code: '+39', continent: '欧洲'}}, {
    region: '法国',
    data: {cnName: '法国', enName: 'France', code: '+33', continent: '欧洲'}
  }, {region: '俄罗斯', data: {cnName: '俄罗斯', enName: 'Russia', code: '+7', continent: '欧洲'}}, {
    region: '希腊',
    data: {cnName: '希腊', enName: 'Greece', code: '+30', continent: '欧洲'}
  }, {region: '荷兰', data: {cnName: '荷兰', enName: 'Netherlands', code: '+31', continent: '欧洲'}}, {
    region: '比利时',
    data: {cnName: '比利时', enName: 'Belgium', code: '+32', continent: '欧洲'}
  }, {region: '西班牙', data: {cnName: '西班牙', enName: 'Spain', code: '+34', continent: '欧洲'}}, {
    region: '匈牙利',
    data: {cnName: '匈牙利', enName: 'Hungary', code: '+36', continent: '欧洲'}
  }, {region: '罗马尼亚', data: {cnName: '罗马尼亚', enName: 'Romania', code: '+40', continent: '欧洲'}}, {
    region: '瑞士',
    data: {cnName: '瑞士', enName: 'Switzerland', code: '+41', continent: '欧洲'}
  }, {region: '奥地利', data: {cnName: '奥地利', enName: 'Austria', code: '+43', continent: '欧洲'}}, {
    region: '丹麦',
    data: {cnName: '丹麦', enName: 'Denmark', code: '+45', continent: '欧洲'}
  }, {region: '瑞典', data: {cnName: '瑞典', enName: 'Sweden', code: '+46', continent: '欧洲'}}, {
    region: '挪威',
    data: {cnName: '挪威', enName: 'Norway', code: '+47', continent: '欧洲'}
  }, {region: '波兰', data: {cnName: '波兰', enName: 'Poland', code: '+48', continent: '欧洲'}}, {
    region: '圣马力诺',
    data: {cnName: '圣马力诺', enName: 'San Marino', code: '+223', continent: '欧洲'}
  }, {region: '直布罗陀', data: {cnName: '直布罗陀', enName: 'Gibraltar', code: '+350', continent: '欧洲'}}, {
    region: '葡萄牙',
    data: {cnName: '葡萄牙', enName: 'Portugal', code: '+351', continent: '欧洲'}
  }, {region: '卢森堡', data: {cnName: '卢森堡', enName: 'Luxembourg', code: '+352', continent: '欧洲'}}, {
    region: '爱尔兰',
    data: {cnName: '爱尔兰', enName: 'Ireland', code: '+353', continent: '欧洲'}
  }, {region: '冰岛', data: {cnName: '冰岛', enName: 'Iceland', code: '+354', continent: '欧洲'}}, {
    region: '阿尔巴尼亚',
    data: {cnName: '阿尔巴尼亚', enName: 'Albania', code: '+355', continent: '欧洲'}
  }, {region: '马耳他', data: {cnName: '马耳他', enName: 'Malta', code: '+356', continent: '欧洲'}}, {
    region: '塞浦路斯',
    data: {cnName: '塞浦路斯', enName: 'Cyprus', code: '+357', continent: '欧洲'}
  }, {region: '芬兰', data: {cnName: '芬兰', enName: 'Finland', code: '+358', continent: '欧洲'}}, {
    region: '保加利亚',
    data: {cnName: '保加利亚', enName: 'Bulgaria', code: '+359', continent: '欧洲'}
  }, {region: '立陶宛', data: {cnName: '立陶宛', enName: 'Lithuania', code: '+370', continent: '欧洲'}}, {
    region: '拉脱维亚',
    data: {cnName: '拉脱维亚', enName: 'Latvia', code: '+371', continent: '欧洲'}
  }, {region: '爱沙尼亚', data: {cnName: '爱沙尼亚', enName: 'Estonia', code: '+372', continent: '欧洲'}}, {
    region: '摩尔多瓦',
    data: {cnName: '摩尔多瓦', enName: 'Moldova Republic of', code: '+373', continent: '欧洲'}
  }, {region: '安道尔共和国', data: {cnName: '安道尔共和国', enName: 'Andorra', code: '+376', continent: '欧洲'}}, {
    region: '乌克兰',
    data: {cnName: '乌克兰', enName: 'Ukraine', code: '+380', continent: '欧洲'}
  }, {region: '塞尔维亚', data: {cnName: '塞尔维亚', enName: 'Serbia', code: '+381', continent: '欧洲'}}, {
    region: '克罗地亚',
    data: {cnName: '克罗地亚', enName: 'Croatia', code: '+385', continent: '欧洲'}
  }, {region: '斯洛文尼亚', data: {cnName: '斯洛文尼亚', enName: 'Slovenia', code: '+386', continent: '欧洲'}}, {
    region: '波黑',
    data: {cnName: '波黑', enName: 'Bosnia and Herzegovina', code: '+387', continent: '欧洲'}
  }, {region: '北马其顿', data: {cnName: '北马其顿', enName: 'North Macedonia', code: '+389', continent: '欧洲'}}, {
    region: '梵蒂冈',
    data: {cnName: '梵蒂冈', enName: 'Vatican', code: '+396', continent: '欧洲'}
  }, {region: '捷克', data: {cnName: '捷克', enName: 'Czech Republic', code: '+420', continent: '欧洲'}}, {
    region: '斯洛伐克',
    data: {cnName: '斯洛伐克', enName: 'Slovakia', code: '+421', continent: '欧洲'}
  }, {region: '列支敦士登', data: {cnName: '列支敦士登', enName: 'Liechtenstein', code: '+423', continent: '欧洲'}}, {
    region: '秘鲁',
    data: {cnName: '秘鲁', enName: 'Peru', code: '+51', continent: '南美洲'}
  }, {region: '墨西哥', data: {cnName: '墨西哥', enName: 'Mexico', code: '+52', continent: '南美洲'}}, {
    region: '古巴',
    data: {cnName: '古巴', enName: 'Cuba', code: '+53', continent: '南美洲'}
  }, {region: '阿根廷', data: {cnName: '阿根廷', enName: 'Argentina', code: '+54', continent: '南美洲'}}, {
    region: '巴西',
    data: {cnName: '巴西', enName: 'Brazil', code: '+55', continent: '南美洲'}
  }, {region: '智利', data: {cnName: '智利', enName: 'Chile', code: '+56', continent: '南美洲'}}, {
    region: '哥伦比亚',
    data: {cnName: '哥伦比亚', enName: 'Colombia', code: '+57', continent: '南美洲'}
  }, {region: '委内瑞拉', data: {cnName: '委内瑞拉', enName: 'Venezuela', code: '+58', continent: '南美洲'}}, {
    region: '福克兰群岛',
    data: {cnName: '福克兰群岛', enName: 'Falkland islands', code: '+500', continent: '南美洲'}
  }, {region: '伯利兹', data: {cnName: '伯利兹', enName: 'Belize', code: '+501', continent: '南美洲'}}, {
    region: '危地马拉',
    data: {cnName: '危地马拉', enName: 'Guatemala', code: '+502', continent: '南美洲'}
  }, {region: '萨尔瓦多', data: {cnName: '萨尔瓦多', enName: 'EI Salvador', code: '+503', continent: '南美洲'}}, {
    region: '洪都拉斯',
    data: {cnName: '洪都拉斯', enName: 'Honduras', code: '+504', continent: '南美洲'}
  }, {region: '尼加拉瓜', data: {cnName: '尼加拉瓜', enName: 'Nicaragua', code: '+505', continent: '南美洲'}}, {
    region: '哥斯达黎加',
    data: {cnName: '哥斯达黎加', enName: 'Costa Rica', code: '+506', continent: '南美洲'}
  }, {region: '巴拿马', data: {cnName: '巴拿马', enName: 'Panama', code: '+507', continent: '南美洲'}}, {
    region: '圣彼埃尔',
    data: {cnName: '圣彼埃尔', enName: 'Saint-Pierre', code: '+508', continent: '南美洲'}
  }, {region: '海地', data: {cnName: '海地', enName: 'Haiti', code: '+509', continent: '南美洲'}}, {
    region: '瓜德罗普',
    data: {cnName: '瓜德罗普', enName: 'Guadeloupe', code: '+590', continent: '南美洲'}
  }, {region: '玻利维亚', data: {cnName: '玻利维亚', enName: 'Bolivia', code: '+591', continent: '南美洲'}}, {
    region: '圭亚那',
    data: {cnName: '圭亚那', enName: 'Guyana', code: '+592', continent: '南美洲'}
  }, {region: '厄瓜多尔', data: {cnName: '厄瓜多尔', enName: 'Ecuador', code: '+593', continent: '南美洲'}}, {
    region: '法属圭亚那',
    data: {cnName: '法属圭亚那', enName: 'French Guiana', code: '+594', continent: '南美洲'}
  }, {region: '巴拉圭', data: {cnName: '巴拉圭', enName: 'Paraguay', code: '+595', continent: '南美洲'}}, {
    region: '马提尼克',
    data: {cnName: '马提尼克', enName: 'Martinique', code: '+596', continent: '南美洲'}
  }, {region: '苏里南', data: {cnName: '苏里南', enName: 'Suriname', code: '+597', continent: '南美洲'}}, {
    region: '乌拉圭',
    data: {cnName: '乌拉圭', enName: 'Uruguay', code: '+598', continent: '南美洲'}
  }, {region: '埃及', data: {cnName: '埃及', enName: 'Egypt', code: '+20', continent: '非洲'}}, {
    region: '南非',
    data: {cnName: '南非', enName: 'South Africa', code: '+27', continent: '非洲'}
  }, {region: '摩洛哥', data: {cnName: '摩洛哥', enName: 'Morocco', code: '+212', continent: '非洲'}}, {
    region: '阿尔及利亚',
    data: {cnName: '阿尔及利亚', enName: 'Algeria', code: '+213', continent: '非洲'}
  }, {region: '突尼斯', data: {cnName: '突尼斯', enName: 'Tunisia', code: '+216', continent: '非洲'}}, {
    region: '利比亚',
    data: {cnName: '利比亚', enName: 'Libya', code: '+218', continent: '非洲'}
  }, {region: '冈比亚', data: {cnName: '冈比亚', enName: 'Gambia', code: '+220', continent: '非洲'}}, {
    region: '塞内加尔',
    data: {cnName: '塞内加尔', enName: 'Senegal', code: '+221', continent: '非洲'}
  }, {region: '毛里塔尼亚', data: {cnName: '毛里塔尼亚', enName: 'Mauritania', code: '+222', continent: '非洲'}}, {
    region: '马里',
    data: {cnName: '马里', enName: 'Mali', code: '+223', continent: '非洲'}
  }, {region: '几内亚', data: {cnName: '几内亚', enName: 'Guinea', code: '+224', continent: '非洲'}}, {
    region: '科特迪瓦',
    data: {cnName: '科特迪瓦', enName: 'Ivory Coast', code: '+225', continent: '非洲'}
  }, {region: '布基纳法索', data: {cnName: '布基纳法索', enName: 'Burkina Faso', code: '+226', continent: '非洲'}}, {
    region: '尼日尔',
    data: {cnName: '尼日尔', enName: 'Niger', code: '+227', continent: '非洲'}
  }, {region: '多哥', data: {cnName: '多哥', enName: 'Togo', code: '+228', continent: '非洲'}}, {
    region: '贝宁',
    data: {cnName: '贝宁', enName: 'Benin', code: '+229', continent: '非洲'}
  }, {region: '毛里求斯', data: {cnName: '毛里求斯', enName: 'Mauritius', code: '+230', continent: '非洲'}}, {
    region: '利比里亚',
    data: {cnName: '利比里亚', enName: 'Liberia', code: '+231', continent: '非洲'}
  }, {region: '塞拉利昂', data: {cnName: '塞拉利昂', enName: 'Sierra Leone', code: '+232', continent: '非洲'}}, {
    region: '加纳',
    data: {cnName: '加纳', enName: 'Ghana', code: '+233', continent: '非洲'}
  }, {region: '尼日利亚', data: {cnName: '尼日利亚', enName: 'Nigeria', code: '+234', continent: '非洲'}}, {
    region: '乍得',
    data: {cnName: '乍得', enName: 'Chad', code: '+235', continent: '非洲'}
  }, {region: '中非', data: {cnName: '中非', enName: 'Central African Republic', code: '+236', continent: '非洲'}}, {
    region: '喀麦隆',
    data: {cnName: '喀麦隆', enName: 'Cameroon', code: '+237', continent: '非洲'}
  }, {region: '佛得角', data: {cnName: '佛得角', enName: 'Cabo Verde', code: '+238', continent: '非洲'}}, {
    region: '圣多美和普林西比',
    data: {cnName: '圣多美和普林西比', enName: 'Sao Tome and Principe', code: '+239', continent: '非洲'}
  }, {
    region: '赤道几内亚',
    data: {cnName: '赤道几内亚', enName: 'Equatorial Guinea', code: '+240', continent: '非洲'}
  }, {region: '加蓬', data: {cnName: '加蓬', enName: 'Gabon', code: '+241', continent: '非洲'}}, {
    region: '刚果',
    data: {cnName: '刚果', enName: 'Congo', code: '+242', continent: '非洲'}
  }, {region: '扎伊尔', data: {cnName: '扎伊尔', enName: 'Zaire', code: '+243', continent: '非洲'}}, {
    region: '安哥拉',
    data: {cnName: '安哥拉', enName: 'Angola', code: '+244', continent: '非洲'}
  }, {region: '几内亚比绍', data: {cnName: '几内亚比绍', enName: 'Guinea-Bissau', code: '+245', continent: '非洲'}}, {
    region: '阿森松',
    data: {cnName: '阿森松', enName: 'Ascension', code: '+247', continent: '非洲'}
  }, {region: '塞舌尔', data: {cnName: '塞舌尔', enName: 'Seychelles', code: '+248', continent: '非洲'}}, {
    region: '苏丹',
    data: {cnName: '苏丹', enName: 'Sudan', code: '+249', continent: '非洲'}
  }, {region: '卢旺达', data: {cnName: '卢旺达', enName: 'Rwanda', code: '+250', continent: '非洲'}}, {
    region: '埃塞俄比亚',
    data: {cnName: '埃塞俄比亚', enName: 'Ethiopia', code: '+251', continent: '非洲'}
  }, {region: '索马里', data: {cnName: '索马里', enName: 'Somali', code: '+252', continent: '非洲'}}, {
    region: '吉布提',
    data: {cnName: '吉布提', enName: 'Djibouti', code: '+253', continent: '非洲'}
  }, {region: '肯尼亚', data: {cnName: '肯尼亚', enName: 'Kenya', code: '+254', continent: '非洲'}}, {
    region: '坦桑尼亚',
    data: {cnName: '坦桑尼亚', enName: 'Tanzania', code: '+255', continent: '非洲'}
  }, {region: '乌干达', data: {cnName: '乌干达', enName: 'Uganda', code: '+256', continent: '非洲'}}, {
    region: '布隆迪',
    data: {cnName: '布隆迪', enName: 'Burundi', code: '+257', continent: '非洲'}
  }, {region: '莫桑比克', data: {cnName: '莫桑比克', enName: 'Mozambique', code: '+258', continent: '非洲'}}, {
    region: '赞比亚',
    data: {cnName: '赞比亚', enName: 'Zambia', code: '+260', continent: '非洲'}
  }, {region: '马达加斯加', data: {cnName: '马达加斯加', enName: 'Madagascar', code: '+261', continent: '非洲'}}, {
    region: '留尼旺岛',
    data: {cnName: '留尼旺岛', enName: 'Reunion Island', code: '+262', continent: '非洲'}
  }, {region: '津巴布韦', data: {cnName: '津巴布韦', enName: 'Zimbabwe', code: '+263', continent: '非洲'}}, {
    region: '纳米比亚',
    data: {cnName: '纳米比亚', enName: 'Namibia', code: '+264', continent: '非洲'}
  }, {region: '马拉维', data: {cnName: '马拉维', enName: 'Malawi', code: '+265', continent: '非洲'}}, {
    region: '莱索托',
    data: {cnName: '莱索托', enName: 'Lesotho', code: '+266', continent: '非洲'}
  }, {region: '博茨瓦纳', data: {cnName: '博茨瓦纳', enName: 'Botswana', code: '+267', continent: '非洲'}}, {
    region: '斯威士兰',
    data: {cnName: '斯威士兰', enName: 'Swaziland', code: '+268', continent: '非洲'}
  }, {region: '科摩罗', data: {cnName: '科摩罗', enName: 'Comoros', code: '+269', continent: '非洲'}}, {
    region: '圣赫勒拿',
    data: {cnName: '圣赫勒拿', enName: 'Saint Helena', code: '+290', continent: '非洲'}
  }, {region: '厄立特里亚', data: {cnName: '厄立特里亚', enName: 'Eritrea', code: '+291', continent: '非洲'}}, {
    region: '阿鲁巴岛',
    data: {cnName: '阿鲁巴岛', enName: 'Aruba', code: '+297', continent: '非洲'}
  }, {region: '法罗群岛', data: {cnName: '法罗群岛', enName: 'Faroe Islands', code: '+298', continent: '非洲'}}, {
    region: '摩纳哥',
    data: {cnName: '摩纳哥', enName: 'Monaco', code: '+377', continent: '非洲'}
  }, {region: '关岛', data: {cnName: '关岛', enName: 'Guam', code: '+671', continent: '大洋洲'}}, {
    region: '瑙鲁',
    data: {cnName: '瑙鲁', enName: 'Nauru', code: '+674', continent: '大洋洲'}
  }, {region: '汤加', data: {cnName: '汤加', enName: 'Tonga', code: '+676', continent: '大洋洲'}}, {
    region: '所罗门群岛',
    data: {cnName: '所罗门群岛', enName: 'Solomon Is', code: '+677', continent: '大洋洲'}
  }, {region: '瓦努阿图', data: {cnName: '瓦努阿图', enName: 'Vanuatu', code: '+678', continent: '大洋洲'}}, {
    region: '斐济',
    data: {cnName: '斐济', enName: 'Fiji', code: '+679', continent: '大洋洲'}
  }, {region: '库克群岛', data: {cnName: '库克群岛', enName: 'The Cook Islands', code: '+682', continent: '大洋洲'}}, {
    region: '纽埃岛',
    data: {cnName: '纽埃岛', enName: 'Niue', code: '+683', continent: '大洋洲'}
  }, {region: '东萨摩亚', data: {cnName: '东萨摩亚', enName: 'Eastern Samoa', code: '+684', continent: '大洋洲'}}, {
    region: '西萨摩亚',
    data: {cnName: '西萨摩亚', enName: 'Samoa Western', code: '+685', continent: '大洋洲'}
  }, {region: '基里巴斯', data: {cnName: '基里巴斯', enName: 'Kiribati', code: '+686', continent: '大洋洲'}}, {
    region: '图瓦卢',
    data: {cnName: '图瓦卢', enName: 'Tuvalu', code: '+688', continent: '大洋洲'}
  }, {region: '科科斯岛', data: {cnName: '科科斯岛', enName: 'Cocos Island', code: '+619162', continent: '大洋洲'}}, {
    region: '诺福克岛',
    data: {cnName: '诺福克岛', enName: 'Norfolk Island', code: '+6723', continent: '大洋洲'}
  }, {region: '圣诞岛', data: {cnName: '圣诞岛', enName: 'Christmas Island', code: '+619164', continent: '大洋洲'}}, {
    region: '美国',
    data: {cnName: '美国', enName: 'United States of America', code: '+1', continent: '北美洲'}
  }, {region: '加拿大', data: {cnName: '加拿大', enName: 'Canada', code: '+1', continent: '北美洲'}}, {
    region: '夏威夷',
    data: {cnName: '夏威夷', enName: 'Hawaii', code: '+1808', continent: '北美洲'}
  }, {region: '阿拉斯加', data: {cnName: '阿拉斯加', enName: 'Alaska', code: '+1907', continent: '北美洲'}}, {
    region: '格陵兰岛',
    data: {cnName: '格陵兰岛', enName: 'Greenland', code: '+299', continent: '北美洲'}
  }, {region: '中途岛', data: {cnName: '中途岛', enName: 'Midway Island', code: '+1808', continent: '北美洲'}}, {
    region: '威克岛',
    data: {cnName: '威克岛', enName: 'Wake Island', code: '+1808', continent: '北美洲'}
  }, {region: '维尔京群岛', data: {cnName: '维尔京群岛', enName: 'Virgin Islands', code: '+1809', continent: '北美洲'}}, {
    region: '波多黎各',
    data: {cnName: '波多黎各', enName: 'Puerto Rico', code: '+1809', continent: '北美洲'}
  }, {region: '巴哈马', data: {cnName: '巴哈马', enName: 'Bahamas', code: '+1809', continent: '北美洲'}}, {
    region: '安圭拉岛',
    data: {cnName: '安圭拉岛', enName: 'Anguilla', code: '+1809', continent: '北美洲'}
  }, {region: '圣卢西亚', data: {cnName: '圣卢西亚', enName: 'St.Lucia', code: '+1809', continent: '北美洲'}}, {
    region: '巴巴多斯',
    data: {cnName: '巴巴多斯', enName: 'Barbados', code: '+1809', continent: '北美洲'}
  }, {region: '牙买加', data: {cnName: '牙买加', enName: 'Jamaica', code: '+1876', continent: '北美洲'}}, {
    region: '南极洲',
    data: {cnName: '南极洲', enName: 'Antarctica', code: '+64672', continent: '南极洲'}
  }
];
